import {TOGGLE_MODAL} from './constant';

export function toggleModal(modal, isOpen) {
  return {
    type: TOGGLE_MODAL,
    payload: {
      modal,
      isOpen
    }
  };
}
